import {Inject, Injectable, PLATFORM_ID} from '@angular/core';
import {isPlatformServer} from '@angular/common';
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from '@angular/router';
import {EMPTY, Observable, of} from 'rxjs';
import {TicketSaleService} from "@biletix/core/services/ticket-sale.service";
import {ShoppingCart} from "@biletix/core/models/shopping-cart/shopping-cart.model";
import {GlobalErrorHandler} from "@biletix/core/services/global-error-handler.service";
import {catchError, map} from "rxjs/operators";
import {RouterService} from "@biletix/core/services/router.service";

@Injectable()
export class ShoppingCartResolver implements Resolve<ShoppingCart> {

    constructor(private ticketSaleService: TicketSaleService,
                private globalErrorHandler: GlobalErrorHandler,
                private routerService: RouterService,
                @Inject(PLATFORM_ID) private platformId: Object) {
    }

    /**
     * Sepeti çözer; SUNUCUDA hiç istek atmaz.
     *
     * İki nedeni var:
     *  - Sepet kullanıcıya özeldir ve `CustomHttpInterceptor` sunucuda
     *    `withCredentials`'ı `false`'a zorluyor, yani SSR'da zaten anonim/boş
     *    bir yanıt alınır — SSR HTML'ine yazılacak anlamlı bir veri yok.
     *  - Hata dalında `EMPTY` dönülüyor. `EMPTY` navigasyonu iptal eder;
     *    @angular/ssr bunu `hasNavigationError` olarak görüp `null` döner ve
     *    Express kendi gövdesiz 404'ünü yayınlar. Bu resolver'ı kullanan
     *    sayfalar (`/football`, `/fan-guide`) `ssrRoutes`'a eklendiğinde CRM
     *    API'deki tek bir aksaklık, sayfayı 200 yerine 404 yapardı.
     *
     * `of(null)` ile kısa devre kalıbı `LoggedInCustomerResolver` ve
     * `RecaptchaResolver`'da da kullanılıyor.
     */
    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<ShoppingCart> | Observable<any> {
        if (isPlatformServer(this.platformId)) {
            return of(null);
        }

        return this.ticketSaleService.getShoppingCart()
            .pipe(
                map((cart: ShoppingCart) => {
                        this.ticketSaleService.setShoppingCart(cart);
                        return cart;
                    }
                ),
                catchError((err) => {
                        this.globalErrorHandler.handleError(err);
                        //TODO: Seam devre dışı kalınca aktif edilecek.
                        // this.routerService.navigateToHomePage();
                        this.routerService.navigateToSeamHomePage();
                        return EMPTY;
                    }
                )
            );
    }
}
